import { BasicCommand } from "~app/common/services/cqs/BasicCommand";
import { CommandType } from "~app/common/services/cqs/CommandType";
import { AlternativMottagningsplats } from "../../../common/alternativMottagningsplats";

export class RemoveKundorderradAlternativaMottagningsplatserCommand extends BasicCommand<RemoveKundorderradAlternativaMottagningsplatserCommand> {
    primaryKey: import("../../../../../../common/services/cqs/IPrimaryKey").IPrimaryKey<RemoveKundorderradAlternativaMottagningsplatserCommand>;
    kundorderradId: number;
    alternativaMottagningsplatser: AlternativMottagningsplats[];

    constructor(kundorderradId: number) {
        super("RemoveKundorderradAlternativaMottagningsplatserCommand", "kundorderrad", CommandType.Replace);
        this.kundorderradId = kundorderradId;
    }
}
